<div class="filter full-span">
  <span class="input-group-btn">
    <button class="btn toggle-btn" [class.off]="!weapon().show" (click)="toggleShowWeapon()"></button>
  </span>
  <span class="filter-body" [class.equipment-filter-from-preset]="weapon().fromProgressPreset || weapon().fromClassPreset">
    <app-autocomplete
      [allowAll]="false"
      [options]="weaponTypes"
      [disabled]="!weapon().show"
      [showOptions]="true"
      [selectedValues]="weapon().weaponType"
      (selectedValuesChange)="weaponTypeChanged($event);"></app-autocomplete>
    <!-- <span class="sep"></span>
    <app-select-comparator [(ngModel)]="weapon().rarityComparator" [allowLessThanOrEqual]="false" (selectedValueChange)="updateFilter()" [disabled]="!weapon().show"></app-select-comparator> -->
    <span class="sep"></span>
    <app-select-rarity [greaterThanOrEqualTo]="true" [includeUnique]="false" [disabled]="!weapon().show" [(ngModel)]="weapon().rarity" (selectedValueChange)="minRarityChanged($event);"></app-select-rarity>
    <span class="sep"></span>
    @if (weapon().baseTypeMode === GearBaseTypeMode.Tier) {
      <app-select-gear-tier [greaterThanOrEqualTo]="true" [disabled]="!weapon().show" [(ngModel)]="weapon().baseTypeTier" (selectedValueChange)="minBaseTypeTierChanged($event);"></app-select-gear-tier>
    } @else {
      <app-autocomplete
        class="my-gear-base-types-autocomplete"
        [allowAll]="true"
        [options]="specificBaseTypeAutocompleteOptions()"
        [disabled]="!weapon().show"
        [showOptions]="true"
        [selectedValues]="weapon().specificBaseTypes"
        (selectedValuesChange)="specificWeaponBaseTypesChanged($event)"></app-autocomplete>
    }
    <span class="sep"></span>
    <span class="input-group-btn">
      <app-tooltip-wrapper [right]="true">
        <button type="button" class="btn toggle-button customize-btn" [class.active]="weapon().baseTypeMode === GearBaseTypeMode.Specific" [disabled]="!weapon().show"
          (click)="toggleWeaponBaseTypeMode()">
          <span class="icon icon-filter"></span>
          <span class="label">{{ weapon().baseTypeMode === GearBaseTypeMode.Tier || weapon().specificBaseTypes[0] === 'All' ? '' : weapon().specificBaseTypes.length }}</span>
        </button>
        <ng-template #tooltip>
          {{ weapon().baseTypeMode === GearBaseTypeMode.Tier
             ? 'Switch to specifying specific base types instead of minimum Gear Tier. Useful for the Recombinator.'
             : 'Switch to specifying minimum Gear Tier instead of specific base types' }}
        </ng-template>
      </app-tooltip-wrapper>
    </span>
    @if (poe2) {
      <span class="sep"></span>
      <app-select style="width: 65px" [disabled]="!weapon().show" [(ngModel)]="weapon().unidentifiedTier" (selectedValueChange)="minUnidentifiedTierChanged($event);">
        <app-option [value]="undefined" [text]="'Any'"></app-option>
        <app-option [value]="2" [text]="'≥ T2'"></app-option>
        <app-option [value]="3" [text]="'≥ T3'"></app-option>
        <app-option [value]="4" [text]="'≥ T4'"></app-option>
        <app-option [value]="5" [text]="'T5'"></app-option>
      </app-select>
    } @else {
      <span class="sep"></span>
      <app-select style="width: 65px" [disabled]="!weapon().show" [(ngModel)]="weapon().minLinks" (selectedValueChange)="updateFilter();">
        <app-option [value]="undefined" [text]="'Any'"></app-option>
        <app-option [value]="'2'" [text]="'≥ 2L'"></app-option>
        <app-option [value]="'3'" [text]="'≥ 3L'"></app-option>
        <app-option [value]="'4'" [text]="'≥ 4L'"></app-option>
        <app-option [value]="'5'" [text]="'≥ 5L'"></app-option>
        <app-option [value]="'6'" [text]="'6L'"></app-option>
      </app-select>
    }
  <span class="sep"></span>
  <input type="number" placeholder="≥ iLvl" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" style="min-width: 55px;"
    [disabled]="!weapon().show"
    [(ngModel)]="weapon().itemLevel" (change)="updateFilter()">

  @if (poe1) {
    <span class="sep"></span>
    <span class="input-group-btn">
      <button class="btn toggle-button customize-btn" [class.no-conditions]="hasAdvancedConditions === 0" [class.active]="advancedConditionsOpen" [class.disabled]="!weapon().show"
        (click)="toggleAdvancedOptionsOpen()">
        <span class="icon icon-cog"></span>
        <span class="label">{{ hasAdvancedConditions }}</span>
      </button>
    </span>
  }

  <span class="sep"></span>
  <span class="input-group-btn">
    <app-tooltip-wrapper [right]="true">
      <button class="btn toggle-button customize-btn" [class.no-conditions]="hasHighlightConfig === 0" [class.active]="highlightConfigOpen" [class.disabled]="!weapon().show"
        (click)="toggleHighlightConfigOpen()">
        <span class="icon icon-equalizer"></span>
        <span class="label">{{ hasHighlightConfig }}</span>
      </button>
      <ng-template #tooltip>Configure which Variants ({{ poe2 ? 'like Unidentified Tiered Gear or Exceptional Gear' : 'like Gear with Memory Strands'}}) of your chosen Weapon Type(s) should be shown and highlighted.</ng-template>
    </app-tooltip-wrapper>
  </span>

  <span class="sep"></span>
  <span class="input-group-btn">
    <button class="btn remove-btn" (click)="removeWeaponType()"></button>
  </span>
  </span>
</div>
@if (poe1 && advancedConditionsOpen) {
  <app-advanced-equipment-conditions
    [isArmour]="false"
    [advancedConditions]="weapon()"
    [isActive]="weapon().show"
    (updateFilterEmitter)="hasAdvancedConditions = getNumberOfAdvancedConditions(); updateFilter()"></app-advanced-equipment-conditions>
  <div class="clear"></div>
}
@if (navigationEnabled || highlightConfigOpen) {
  <div [class.collapsed]="!highlightConfigOpen">
    <app-my-equipment-highlights
      [equipment]="weapon()"
      [gearOrJewellery]="weapon()"
      [gear]="weapon()"
      [equipmentType]="'weapon'"
      [equipmentIndex]="index()"
      (updateFilterEmitter)="hasHighlightConfig = getNumberOfHighlightConfig(); updateFilter()"></app-my-equipment-highlights>
    <div class="clear"></div>
  </div>
}
